import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import { browserHistory } from 'react-router';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import Opration from '@comm/workflow/WorkflowOp';
import Comment from '@comm/comment/Index';

import moment from 'moment';
import { queryCallbackRecoup, queryNextRecoup, queryReturnRecoup } from '@api/finance/recoup';
import FormOpen from './FormOpen';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 处理流程
   */
  doTask = (pass, refuse) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackRecoup(item);
        break;
      case 'next':
        this.nextRecoup(item);
        break;
      case 'return':
        this.returnRecoup(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  callbackRecoup = params => {
    queryCallbackRecoup(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextRecoup = params => {
    this.setState({ isLoading: true });
    queryNextRecoup(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnRecoup = (params, refuse) => {
    queryReturnRecoup({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        render: text => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null}</span>
        ),
      },
      {
        title: '操作内容',
        dataIndex: 'operating',
      },
      {
        title: '处理意见',
        dataIndex: 'refuse',
      },
    ];
  };

  render() {
    const { dataInfo, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];
    return (
      <div>
        <Opration
          data={dataInfo}
          doTask={this.doTask}
          watchTask={this.watchTask}
          isLoading={isLoading}
        />
        <FormOpen data={dataInfo} doTask={this.doTask} watchTask={this.watchTask} {...this.props} />
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'recoup', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/expenses/PageOpen.js